import styled from "styled-components";

export const ErrorBanner = ({ text }) => {
  return <ErrorWrapper>{text}</ErrorWrapper>;
};

const ErrorWrapper = styled.p`
  width: 100%;
  padding: 0.5rem 0.5rem;
  margin-bottom: 1rem;
  border-radius: 30px;
  opacity: 0.8;
  font-size: 0.8rem;
  display: inline-block;
  background-color: red;
  color: white;
  text-align: center;
`;
